import FnTableItemComponent from './FnTableItemComponent';

const FnTableWrapper = ({ data, type, totalrow, showAction, handleAction }) => {

    return (
        <div className="card shadow mb-4">
            <div className="">
                <div className="table-responsive">
                    <div id="dataTable_wrapper" className="dataTables_wrapper dt-bootstrap4">
                        <div className="">
                            <div className="">
                                <FnTableItemComponent data={data} totalrow={totalrow} showAction={showAction} handleAction={handleAction} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FnTableWrapper;
